import { ApprovalProject } from '../approval/types';

export type ArchiveState = {
  loading: boolean;
  error: string;
  projects: ApprovalProject[];
};

export const initialState: ArchiveState = {
  loading: false,
  error: null,
  projects: [],
};
